import { useEffect } from "react";
import { useSetPageHeaderFn } from "@/components/layout/PageHeaderContext";

const useSetPageHeader = (title, subtitle = '', icon) => {
    const setHeader = useSetPageHeaderFn();
    useEffect(() => {
        setHeader({ title, subtitle, icon });
        return () => setHeader({ title: '', subtitle: '', icon: null });
    }, [title, subtitle, icon]);
};

export default useSetPageHeader;
